module.exports = __webpack_public_path__ + "static/img/Risk250108TW.def2ddf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Risk250108TW.jpg
// module id = Mpvf
// module chunks = 1